import { OrnateDivider } from './KeralaDecor';
import MenuItem from './MenuItem';
import './MenuSection.css';

export default function MenuSection({ section }) {
  return (
    <section className="ms" id={section.id}>
      <OrnateDivider />
      <header className="ms__head">
        {section.eyebrow && <span className="eyebrow-script">{section.eyebrow}</span>}
        <h2 className="ms__title">{section.title}</h2>
        {section.note && <p className="ms__note">{section.note}</p>}
      </header>
      <div className="ms__grid">
        {section.items.map((item) => (
          <MenuItem key={item.name} item={item} />
        ))}
      </div>
    </section>
  );
}
